import React, { Component } from 'react';
import Datas from '../../data/faq/faq.json';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/faq.js';

class Faq extends Component {
    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper faq-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcrumb */}
                    <BreadcrumbBox title="Frequently Asked Questions" />

                    {/* Faq Area */}
                    <section className="faq-area">
                        <Container>
                            <Row>
                                <Col md="12">
                                    <Tab.Container defaultActiveKey="general">
                                        <Nav className="justify-content-center">
                                            <Nav.Item><Nav.Link eventKey="general">General</Nav.Link></Nav.Item>
                                            <Nav.Item><Nav.Link eventKey="admission">Admission</Nav.Link></Nav.Item>
                                            <Nav.Item><Nav.Link eventKey="courses">Courses</Nav.Link></Nav.Item>
                                            <Nav.Item><Nav.Link eventKey="campus">Campus</Nav.Link></Nav.Item>
                                            <Nav.Item><Nav.Link eventKey="support">Support</Nav.Link></Nav.Item>
                                        </Nav>

                                        <Tab.Content>
                                            <Tab.Pane eventKey="general">
                                                <Row>
                                                    {Datas.filter((data) => data.category === "general").map((data, i) => (
                                                        <Col md="6" key={i}>
                                                            <div className="faq-item">
                                                                <div className="faq-title d-flex">
                                                                    <div className="title-icon"><span>Q</span></div>
                                                                    <div className="title-text"><p>{data.faqTitle}</p></div>
                                                                </div>
                                                                <div className="faq-desc">
                                                                    <p>{data.faqDesc}</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="admission">
                                                <Row>
                                                    {Datas.filter((data) => data.category === "admission").map((data, i) => (
                                                        <Col md="6" key={i}>
                                                            <div className="faq-item">
                                                                <div className="faq-title d-flex">
                                                                    <div className="title-icon"><span>Q</span></div>
                                                                    <div className="title-text"><p>{data.faqTitle}</p></div>
                                                                </div>
                                                                <div className="faq-desc">
                                                                    <p>{data.faqDesc}</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="courses">
                                                <Row>
                                                    {Datas.filter((data) => data.category === "courses").map((data, i) => (
                                                        <Col md="6" key={i}>
                                                            <div className="faq-item">
                                                                <div className="faq-title d-flex">
                                                                    <div className="title-icon"><span>Q</span></div>
                                                                    <div className="title-text"><p>{data.faqTitle}</p></div>
                                                                </div>
                                                                <div className="faq-desc">
                                                                    <p>{data.faqDesc}</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="campus">
                                                <Row>
                                                    {Datas.filter((data) => data.category === "campus").map((data, i) => (
                                                        <Col md="6" key={i}>
                                                            <div className="faq-item">
                                                                <div className="faq-title d-flex">
                                                                    <div className="title-icon"><span>Q</span></div>
                                                                    <div className="title-text"><p>{data.faqTitle}</p></div>
                                                                </div>
                                                                <div className="faq-desc">
                                                                    <p>{data.faqDesc}</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="support">
                                                <Row>
                                                    {Datas.filter((data) => data.category === "support").map((data, i) => (
                                                        <Col md="6" key={i}>
                                                            <div className="faq-item">
                                                                <div className="faq-title d-flex">
                                                                    <div className="title-icon"><span>Q</span></div>
                                                                    <div className="title-text"><p>{data.faqTitle}</p></div>
                                                                </div>
                                                                <div className="faq-desc">
                                                                    <p>{data.faqDesc}</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />
                </div>
            </Styles>
        )
    }
}

export default Faq;